import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	components: {
		app: {
			globalInputIdentifiers: [
				'my-custom-input',
			],
			applicationId: 'test-application',
			listenFor: [
				{
					appId: 'ksys-global-inputs',
					eventTypes: [{
						name: 'ksys-global-inputs-change',
						requiredForInitialLoad: false,
					}],
				},
				{
					appId: 'ksys-pagination',
					eventTypes: [{
						name: 'ksys-on-pagination-change',
						requiredForInitialLoad: true,
						runOnce: false,
						cache: {
							enabled: true,
						},
					}],
				},
			],
		},
		disclaimers: {
			pageDisclaimers: {
				position: 'above',
				enabled: true,
			},
			queries: {
				disclaimers: [
					{
						text: {
							queryOptionsType: 'none',
							value: 'This is a dynamic disclaimer... but not',
						},
					},
				],
			},
		},
	},
};
